<template src="./ArrivalUpdateOrCreateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {ref, computed, onMounted, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRoute, useRouter} from "vue-router";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useArrivalStore} from "@/stores/arrival.js";
import SelectCustomWithSearch from "@/components/inputs/select/custom-with-search/SelectCustomWithSearch.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalWarehouseListComponent from "@/components/modals/modal-warehouse-list/ModalWarehouseListComponent.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import {AppConstant} from "@/supports/app.constant.js";
export default {
  name: 'ArrivalUpdateOrCreateComponent',
  computed: {
    AppConstant() {
      return AppConstant
    }
  },
  components: {
    InputDateTimeNormal,
    ModalWarehouseListComponent,
    ModalDeliveryProductListComponent, LoadingComponent,
    SelectCustomWithSearch,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const mode = ref('create')
    const arrival_id = ref(null)
    const labelButtonSetting = ref('Tạo nhập hàng')
    const usingWarehouse = ref(null)
    const dataArrival = ref({
      warehouse_from_name: {
        id: 'warehouse_from_name',
        label: 'Nơi cung cấp',
        placeholder: 'Nơi cung cấp',
        value: '',
        error: '',
        isError: false,
      },
      warehouse_from_code: {
        id: 'warehouse_from_code',
        label: 'Mã nơi cung cấp',
        placeholder: 'Mã nơi cung cấp',
        value: '',
        error: '',
        isError: false,
      },
      warehouse_from_addr: {
        id: 'warehouse_from_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
      },
      warehouse_to_name: {
        id: 'warehouse_to_name',
        label: 'Nơi nhập hàng',
        placeholder: 'Nơi nhập hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        readonly: true
      },
      warehouse_to_code: {
        id: 'warehouse_to_code',
        label: 'Mã kho',
        placeholder: 'Mã kho',
        value: '',
        error: '',
        isError: false,
        readonly: true
      },
      warehouse_to_addr: {
        id: 'warehouse_to_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
        readonly: true
      },
      product_name_arrival: {
        id: 'product_name_arrival',
        label: 'Sản phẩm',
        placeholder: 'Sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: true,
        readonly: true
      },
      product_code_arrival: {
        id: 'product_code_arrival',
        label: 'Mã sản phẩm',
        placeholder: 'Mã sản phẩm',
        value: '',
        error: '',
        isError: false,
        readonly: true
      },
      product_quantity: {
        id: 'product_quantity',
        label: 'Số lượng nhập hàng',
        placeholder: 'Số lượng nhập hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: true
      },
      expected_arrival_date: {
        id: 'expected_arrival_date',
        label: 'Ngày dự kiến đến',
        placeholder: 'Ngày dự kiến đến',
        value: '',
        error: '',
        isError: false,
      },
      arrival_date: {
        id: 'arrival_date',
        label: 'Ngày nhập hàng',
        placeholder: 'Ngày nhập hàng',
        value: '',
        error: '',
        isError: false,
      },
      expected_departure_date: {
        id: 'expected_departure_date',
        label: 'Ngày dự kiến xuất phát',
        placeholder: 'Ngày dự kiến xuất phát',
        value: '',
        error: '',
        isError: false,
      },
      departure_date: {
        id: 'departure_date',
        label: 'Ngày xuất phát',
        placeholder: 'Ngày xuất phát',
        value: '',
        error: '',
        isError: false,
      },
    })
    const eventClickShowModalProduct = ref(false)
    const eventClickShowModalWarehouse = ref(false)
    const listProductsSelected = ref([])
    const listWarehousesSelected = ref([])
    const typeSelectWarehouse = ref('single')
    const warehouseSelected = ref(null)
    const productSelected = ref(null)
    const statusArrivalCurrent = ref(1)
    const typeSelectProduct = ref('single')
    const isLoading = ref(false)
    const stateModal = reactive({
      modalDeliveryProductList: null,
      modalWarehouseList: null,
    })
    const router = useRouter()
    const route = useRoute()
    const accountStore = useAccountStore()
    const warehouseStore = useWarehouseStore()
    const arrivalStore = useArrivalStore()

    onMounted(() => {
      mode.value = route.params.mode;
      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập chỉ thị';
        arrival_id.value =  route.params.id;
        getDataArrivalDetail();
      }
      stateModal.modalDeliveryProductList = new bootstrap.Modal('#modaldeliveryProduct', {})
      stateModal.modalWarehouseList = new bootstrap.Modal('#modalWarehouse', {})
    });

    async function createOrUpdateArrival() {
      for (const item in dataArrival.value) {
        validateForm(dataArrival.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          product_id: productSelected.value,
          warehouse_id: warehouseSelected.value,
          quantity: dataArrival.value.product_quantity.value,
          expected_arrival_date: dataArrival.value.expected_arrival_date.value,
          arrival_date: dataArrival.value.arrival_date.value,
          departure_date: dataArrival.value.departure_date.value,
          warehouse_from_name: dataArrival.value.warehouse_from_name.value,
          warehouse_from_code: dataArrival.value.warehouse_from_code.value,
          warehouse_from_addr: dataArrival.value.warehouse_from_addr.value,
          id: arrival_id.value,
        }
        let url = AppConstant.URL_API_LOCAL + 'api/arrival/create-arrival';
        if(mode.value === 'detail') {
          params.id = arrival_id.value;
          url = AppConstant.URL_API_LOCAL + 'api/arrival/update-arrival';
        }
        const warehouse = await warehouseStore.createOrUpdateWarehouse(url, params);
        await CommonService.showAlertPopup({
          title: warehouse?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });

        await router.push('/warehouse/arrival')
      }
    }

    watch(() => warehouseStore.warehouse, (newWarehouse) => {
      dataArrival.value.warehouse_from_name.value = newWarehouse.name;
      dataArrival.value.warehouse_to_name.value = newWarehouse.code;
      dataArrival.value.warehouse_phone.value = newWarehouse.phone;
      dataArrival.value.warehouse_address.value = newWarehouse.address;
    });

    watch(() => arrivalStore.arrival, (newArrival) => {
      dataArrival.value.warehouse_to_name.value = newArrival.warehouse.name;
      dataArrival.value.warehouse_to_code.value = newArrival.warehouse.code;
      dataArrival.value.warehouse_to_addr.value = newArrival.warehouse.address;
      dataArrival.value.product_name_arrival.value = newArrival.product.product_name;
      dataArrival.value.product_code_arrival.value = newArrival.product.product_code_arrival;
      dataArrival.value.product_quantity.value = newArrival.quantity;
      dataArrival.value.expected_arrival_date.value = newArrival.expected_arrival_date;
      dataArrival.value.arrival_date.value = newArrival.arrival_date;
      dataArrival.value.expected_departure_date.value = newArrival.expected_departure_date;
      dataArrival.value.departure_date.value = newArrival.departure_date;
      dataArrival.value.warehouse_from_name.value = newArrival.warehouse_from_name;
      dataArrival.value.warehouse_from_code.value = newArrival.warehouse_from_code;
      dataArrival.value.warehouse_from_addr.value = newArrival.warehouse_from_addr;
      statusArrivalCurrent.value = newArrival.status;
      productSelected.value = newArrival.product.id;
      warehouseSelected.value = newArrival.warehouse.id;
    });

    function getDataArrivalDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        arrival_id: arrival_id.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/arrival/detail';
      arrivalStore.getArrivalDetail(url, params);
    }
    function onChange(value, name) {
      dataArrival.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'warehouse_to_name') {
        dataArrival.value.warehouse_to_name.isError = false;
        dataArrival.value.warehouse_to_name.error = ''
        errors.value = false
        if(!value) {
          dataArrival.value.warehouse_to_name.isError = true;
          dataArrival.value.warehouse_to_name.error = ErrorText.REQUIRED(dataArrival.value.warehouse_to_name.label);
          errors.value = true
        }
      }
      if(name === 'product_name_arrival') {
        dataArrival.value.product_name_arrival.isError = false;
        dataArrival.value.product_name_arrival.error = ''
        errors.value = false
        if(!value) {
          dataArrival.value.product_name_arrival.isError = true;
          dataArrival.value.product_name_arrival.error = ErrorText.REQUIRED(dataArrival.value.product_name_arrival.label);
          errors.value = true
        }
      }
      if(name === 'product_quantity') {
        dataArrival.value.product_quantity.isError = false;
        dataArrival.value.product_quantity.error = ''
        errors.value = false
        if(!value) {
          dataArrival.value.product_quantity.isError = true;
          dataArrival.value.product_quantity.error = ErrorText.REQUIRED(dataArrival.value.product_quantity.label);
          errors.value = true
        }
      }
      if(name === 'expected_arrival_date') {
        dataArrival.value.expected_arrival_date.isError = false;
        dataArrival.value.expected_arrival_date.error = ''
        errors.value = false
        if(value && new Date(value) <= new Date()) {
          dataArrival.value.expected_arrival_date.isError = true;
          dataArrival.value.expected_arrival_date.error = ErrorMessageConstant.ERROR_ARRIVAL_VALIDATE_DATE;
          errors.value = true
        }
      }
      if(name === 'arrival_date') {
        dataArrival.value.arrival_date.isError = false;
        dataArrival.value.arrival_date.error = ''
        errors.value = false
        if(value && new Date(value) <= new Date()) {
          dataArrival.value.arrival_date.isError = true;
          dataArrival.value.arrival_date.error = ErrorMessageConstant.ERROR_ARRIVAL_VALIDATE_DATE;
          errors.value = true
        }
      }
      if(name === 'arrival_date') {
        dataArrival.value.expected_departure_date.isError = false;
        dataArrival.value.expected_departure_date.error = ''
        errors.value = false
        if(value && dataArrival.value.arrival_date.value && new Date(value) > new Date(dataArrival.value.arrival_date.value)) {
          dataArrival.value.expected_departure_date.isError = true;
          dataArrival.value.expected_departure_date.error = ErrorMessageConstant.ERROR_ARRIVAL_VALIDATE_DEPARTURE_DATE;
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function showModalProductList() {
      eventClickShowModalProduct.value = true
      isLoading.value = true
    }
    function showModalWarehouseList() {
      eventClickShowModalWarehouse.value = true
      isLoading.value = true
    }
    function showModalProduct(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalProduct.value = false
          isLoading.value = false
          stateModal.modalDeliveryProductList.show()
        }, 1000);
        return;
      }
      stateModal.modalDeliveryProductList.hide()
    }
    function showModalWarehouse(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalWarehouse.value = false
          isLoading.value = false
          stateModal.modalWarehouseList.show()
        }, 1000);
        return;
      }
      stateModal.modalWarehouseList.hide()
    }
    function eventSearchProduct(isSearch) {
      if(!eventClickShowModalProduct.value) {
        isLoading.value = isSearch
      }
    }
    function eventSearchWarehouse(isSearch) {
      if(!eventClickShowModalWarehouse.value) {
        isLoading.value = isSearch
      }
    }
    function eventGetListProductsSelected(listProductsSelectedCurrent) {
      listProductsSelected.value = listProductsSelectedCurrent
      if(Object.keys(listProductsSelected.value).length > 0) {
        dataArrival.value.product_name_arrival.value = listProductsSelected.value[0].product_name_arrival;
        dataArrival.value.product_code_arrival.value = listProductsSelected.value[0].product_code_arrival;
        productSelected.value = listProductsSelected.value[0].id;
      }
    }
    function eventGetListWarehousesSelected(listWarehousesSelectedCurrent) {
      listWarehousesSelected.value = listWarehousesSelectedCurrent
      if(Object.keys(listWarehousesSelected.value).length > 0) {
        dataArrival.value.warehouse_to_name.value = listWarehousesSelected.value[0].name;
        dataArrival.value.warehouse_to_code.value = listWarehousesSelected.value[0].code;
        dataArrival.value.warehouse_to_addr.value = listWarehousesSelected.value[0].address;
        warehouseSelected.value = listWarehousesSelected.value[0].id;
      }
    }

    return {
      createOrUpdateArrival,
      dataArrival,
      mode,
      usingWarehouse,
      labelButtonSetting,
      statusArrivalCurrent,
      CommonService,
      errors,
      onChange,
      validateForm,
      checkSubmitActive,
      showModalProduct,
      showModalWarehouse,
      eventSearchProduct,
      eventSearchWarehouse,
      eventGetListProductsSelected,
      eventGetListWarehousesSelected,
      showModalProductList,
      showModalWarehouseList,
      eventClickShowModalProduct,
      eventClickShowModalWarehouse,
      listProductsSelected,
      listWarehousesSelected,
      typeSelectWarehouse,
      typeSelectProduct,
      isLoading
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .list-arrivals-component {
          margin-top: 30px;
          #warehouse_to_name,
          #warehouse_to_code,
          #warehouse_to_addr,
          #product_name_arrival,
          #product_code_arrival
          {
            background-color: #ffffff;
          }
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
